import React from 'react'
import styled from 'styled-components'
import { string } from 'prop-types'
import { stripUnit } from 'polished'

import { white } from 'styles/colors'
import { square } from 'styles/global'
import { media, mediaDown } from 'styles/media'
import { H3 } from 'styles/typography'
import * as spacing from 'styles/spacing'
import Icon from 'components/Icon'

const Container = styled.div`
  display: flex;

  & + & {
    margin-top: ${spacing.large};

    ${media.small`
      margin-top: ${spacing.xLarge};
    `};

    ${media.large`
      margin-top: ${spacing.xxLarge};
    `};

    ${media.xLarge`
      margin-top: 56px;
    `};
  }
`

const Number = styled(H3)`
  flex-shrink: 0;
  color: ${white};
  width: 24px;
  margin-right: ${spacing.small};

  ${media.medium`
    margin-right: ${spacing.large};
  `};

  ${media.large`
    margin-right: ${spacing.xLarge};
  `};

  ${media.xLarge`
    margin-right: ${spacing.xxLarge};
  `};

  &:before {
    counter-increment: steps;
    content: counter(steps) '. ';

    ${media.medium`
      content: counter(steps);
    `};
  }
`

const Heading = styled(H3)`
  color: ${white};
  margin-bottom: ${spacing.small};

  ${media.medium`
    margin-bottom: ${stripUnit(spacing.small) * 1.5 + 'px'};
  `};

  ${media.xLarge`
    margin-bottom: ${spacing.medium};
  `};
`

const IconWrap = styled.div`
  flex-shrink: 0;
  margin-right: ${spacing.xxLarge};
  margin-top: -${spacing.tiny};
  color: ${white};
  ${square('48px')};

  ${media.xLarge`
    margin-right: ${spacing.xxxLarge};
  `};

  ${mediaDown.large`
    display: none;
  `};
`

const PlusFeature = ({ heading, description, icon }) => (
  <Container>
    <IconWrap>
      <Icon icon={icon} size="xLarge" />
    </IconWrap>
    <Number />
    <div>
      <Heading>{heading}</Heading>
      <p>{description}</p>
    </div>
  </Container>
)

PlusFeature.propTypes = {
  heading: string.isRequired,
  icon: string.isRequired,
  description: string.isRequired
}

export default PlusFeature
